export default __webpack_public_path__ + "static/media/huy.2e3d98c2.jpeg";